import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import has from 'lodash/has';
import { featureToFeatureCollection } from '@topconagriculture/map-utils';
import { notificationsConfig } from '../../config/constants';
import { useDashboardAPI } from '../../hooks';
export const useGeoJSONListQuery = () => {
    const dispatch = useDispatch();
    const api = useDashboardAPI();
    return useQuery({
        queryKey: ['geoFeatures'],
        queryFn: () => api.field.getFields(),
        select: (data) => {
            const featureList = data.data
                .filter((field) => has(field, 'geometry.geometry.coordinates'))
                .map((field) => field.geometry.geometry);
            return featureToFeatureCollection(featureList);
        },
        onError: (err) => {
            if (err.status !== 403) {
                dispatch(error({
                    ...notificationsConfig.defaultConf,
                    translationKey: 'widget::cant_load_vehicle_list',
                }));
            }
        },
    });
};
//# sourceMappingURL=useGeoJSONListQuery.js.map